var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from '@app/core/services/alert.service';
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { selectRoleDetail, LoadingRoleDetailsAction, selectPolicies, LoadingPolicyAction } from '@app/access-management/state';
import { take, filter, map } from 'rxjs/operators';
import { Policy, readParameterFromRouterState, RoleDetail, MaybeLoadable, Loaded, needsLoading, Loadable, GoAction, IAM_ROUTE, RolesService, Role } from '@app/core';
var shouldLoadRole = function (roleDetail) {
    return roleDetail === undefined || roleDetail.role === undefined;
};
var ɵ0 = shouldLoadRole;
var shouldLoadPolicies = function (policies) { return needsLoading(policies); };
var ɵ1 = shouldLoadPolicies;
var hasPoliciesState = function (policies) { return !needsLoading(policies); };
var ɵ2 = hasPoliciesState;
var RolePoliciesFormComponent = /** @class */ (function () {
    function RolePoliciesFormComponent(activatedRoute, store, alertService, roleService) {
        var _this = this;
        this.store = store;
        this.alertService = alertService;
        this.roleService = roleService;
        this.submitSubscription = undefined;
        this.selectedPolicies = undefined;
        this.policyColumns = [
            { name: 'Policy Name', prop: 'name' },
            { name: 'Policy Description', prop: 'description', cellClass: 'white-space-normal' }
        ];
        var roleId = readParameterFromRouterState(activatedRoute, 'id');
        if (roleId === undefined) {
            throw new Error('role id not in route');
        }
        this.roleId = roleId;
        var maybeRoleDetail$ = this.store.pipe(select(selectRoleDetail(this.roleId)));
        maybeRoleDetail$
            .pipe(take(1), filter(function (roleDetail) { return shouldLoadRole(roleDetail); }))
            .subscribe(function () { return store.dispatch(new LoadingRoleDetailsAction(_this.roleId)); });
        this.roleDetail$ = maybeRoleDetail$.pipe(filter(function (roleDetail) { return roleDetail !== undefined; }));
        this.role$ = this.roleDetail$.pipe(map(function (roleDetail) { return roleDetail.role; }));
        this.loadablePolicies$ = this.store.pipe(select(selectPolicies));
        this.loadablePolicies$
            .pipe(take(1), filter(shouldLoadPolicies))
            .subscribe(function () { return store.dispatch(new LoadingPolicyAction()); });
        this.policies$ = this.loadablePolicies$.pipe(filter(hasPoliciesState), map(function (policyList) { return policyList.data; }));
        this.rolePolicies$ = this.roleService.getRolePolicies(this.roleId)
            .pipe(map(function (list) { return list.map(function (row) { return (__assign({}, row, { id: row.policy_id })); }).slice(); }));
    }
    RolePoliciesFormComponent.prototype.ngOnInit = function () { };
    RolePoliciesFormComponent.prototype.ngOnDestroy = function () {
        if (this.submitSubscription !== undefined) {
            this.submitSubscription.unsubscribe();
        }
    };
    RolePoliciesFormComponent.prototype.onSelectPolicy = function (selectedPolicies) {
        this.selectedPolicies = selectedPolicies;
    };
    RolePoliciesFormComponent.prototype.onSelectRows = function (rows) {
        this.selectedPolicies = rows.selected;
    };
    RolePoliciesFormComponent.prototype.submit = function () {
        var _this = this;
        var request = {
            policyIds: this.selectedPolicies && this.selectedPolicies.map(function (p) { return p.id; })
        };
        this.roleService.updateRoleByPolicyIds(this.roleId, request).subscribe(function (_) {
            _this.goToRoleDetailsPage();
            _this.store.dispatch(new LoadingRoleDetailsAction(_this.roleId));
            _this.alertService.success("Policies have successfully been attached to this role.");
        }, function (err) {
            _this.alertService.error("Failed to attached policies to this role.");
        });
    };
    RolePoliciesFormComponent.prototype.cancel = function () {
        // Todo: probably need to clear policy selection state
        this.goToRoleDetailsPage();
    };
    RolePoliciesFormComponent.prototype.getUpdateRolePolicyRequest = function (roleDetail, newPolicies) {
        var policyIds = roleDetail.policies !== undefined ? roleDetail.policies.map(function (policy) { return policy.id; }) : [];
        var newPolicyIds = newPolicies !== undefined ? newPolicies.map(function (policy) { return policy.id; }) : [];
        return {
            policyIds: Array.from(new Set(policyIds.concat(newPolicyIds))) // remove dups in case
        };
    };
    RolePoliciesFormComponent.prototype.goToRoleDetailsPage = function () {
        this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'roles', this.roleId]));
    };
    return RolePoliciesFormComponent;
}());
export { RolePoliciesFormComponent };
export { ɵ0, ɵ1, ɵ2 };



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-policies-form/role-policies-form.component.ts.pre-build-optimizer.js